import React, { useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import LoginComponent from 'components/Login';
import VerifyOtpComponent from 'components/Login/VerifyOtp';
import EmrSMSComponent from 'components/EmrSMS';
import DoctorSearch from 'components/DoctorSearch';
import DoctorProfile from 'components/DoctorProfile';
import ConfirmAppointment from 'components/Appointment/PatientConfirm';
import ProtectedRoutes from './ProtectedRoutes';
import { clearPending } from 'services/axiosReqCancel';

function Routes() {
  const location = useLocation();

  useEffect(() => {
    return () => clearPending();
  }, [location?.pathname]);

  return (
    <Switch>
      <Route exact path={'/'} component={LoginComponent} />
      <Route exact path={'/verifyotp'} component={VerifyOtpComponent} />
      <Route exact path={'/emrSMS'} component={EmrSMSComponent} />
      <Route exact path={'/doctors/search'} component={DoctorSearch} />
      <Route exact path={'/doctors/:shortUrl'} component={DoctorProfile} />
      <Route exact path={'/confirm/:appointmentId'} component={ConfirmAppointment} />
      <Route component={ProtectedRoutes} />
    </Switch>
  );
}

export default Routes;